var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('b-nav-text',{staticClass:"py-0 user-limit"},[_vm._v(_vm._s(_vm.getUser.name))]),_vm._v(" "),_c('p',{staticClass:"py-0 version mb-0"},[_vm._v("2.2.1.6")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0365a700","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/node_modules/string-replace-loader??ref--5!/src/view/header/LoggedUser.vue
// module id = null
// module chunks = 